import cx from 'classnames';
import React, {useState} from 'react';
import {Step1} from './steps/Step1';
import {Step2} from './steps/Step2';
import {Step2b} from './steps/Step2b';
import {Step3b} from './steps/Step3b';
import {Step3} from './steps/Step3';
import {Step4} from './steps/Step4';
import {Popup} from './dashboardPopup/Popup';
import {H1} from '../../components/crousal/Headings';
import {ISkinsAndChampions} from '../../common/types/SkinsAndChampions';
import {ACCOUNTS} from '../../common/constants/accounts';
import {IRegions, IRanks} from '../../common/types/RegionsAndRanks';

interface IProps {
    skinsAndChampions: ISkinsAndChampions[];
    regions: IRegions[];
    ranks: IRanks[];
}

export function Dashboard({skinsAndChampions, regions, ranks}: IProps) {
    const [steps, setSteps] = useState(1);
    const [accountType, setAccountType] = useState('');

    function renderSteps() {
        switch (steps) {
            case 1:
                return <Step1 onChange={setSteps} availableAccountType={setAccountType}/>
            case 2:
                if (accountType === ACCOUNTS.highEnd) {
                    return <Step2 onChange={setSteps} skinsAndChampions={skinsAndChampions}/>
                } else {
                    return <Step2b onChange={setSteps} regions={regions} ranks={ranks}/>
                }
            case 3:
                if (accountType === ACCOUNTS.highEnd) {
                    return <Step3 onChange={setSteps}/>
                } else {
                    return <Step3b onChange={setSteps}/>
                }
            case 4:
                return <Step4 onChange={setSteps}/>
            default:
                return null;
        }
    }

    return (
        <div className="items-center justify-content-center text-center">
            <H1 className="mt-10 lg:mt-16">Sell Your LoL Account</H1>
            <div className="mt-2 text-sm text-center lg:w-2/5 lg:mx-auto p-2 lg:p-6 text-30">
                To accurately describe and sell your account we will need some information from you first. We treat
                high-end accounts (a lot of skins or rare skin accounts) differently than accounts without exceptional
                skins. Want to know more?
                Read about it <span className="text-smurfs-gold cursor-pointer">here.</span>
            </div>
            <div
                className="h-1/2 mt-2 mb-4 flex column justify-center items-center text-center lg:w-3/5 lg:mx-auto p-4 bg-medium-black">
                <div
                    className="w-10 h-10 lg:ml-4 bg-smog-grey rounded-full items-center flex justify-center text-center">
                    <div
                        className={cx(
                            "w-6 h-6 rounded-full flex items-center justify-center text-center",
                            steps === 1 ? 'bg-medal-gold' : 'bg-40',
                        )}
                    >
                        <p className="text-absolute-black">1</p>
                    </div>
                </div>
                <div className="ml-2 flex items-center justify-center text-center text-xs">
                    Type of the account you want to sell
                    <i className="fas ml-4 text-metallic-grey text-md fa-angle-right"/>
                </div>

                <div
                    className="w-10 h-10 lg:ml-4 bg-smog-grey rounded-full items-center flex justify-center text-center">
                    <div
                        className={cx(
                            "w-6 h-6 rounded-full flex items-center justify-center text-center",
                            steps === 2 ? 'bg-medal-gold' : 'bg-40',
                        )}
                    >
                        <p className="text-absolute-black">2</p>
                    </div>
                </div>
                <div className="ml-2 flex items-center justify-center text-center text-xs">
                    Describe your account
                    <i className="fas ml-4 text-metallic-grey text-md fa-angle-right"/>
                </div>

                <div
                    className="w-10 h-10 lg:ml-4 bg-smog-grey rounded-full items-center flex justify-center text-center">
                    <div
                        className={cx(
                            "w-6 h-6 rounded-full flex items-center justify-center text-center",
                            steps === 3 ? 'bg-medal-gold' : 'bg-40',
                        )}
                    >
                        <p className="text-absolute-black">3</p>
                    </div>
                </div>
                <div className="ml-2 flex items-center justify-center text-center text-xs">
                    Pricing
                    <i className="fas ml-4 text-metallic-grey text-md fa-angle-right"/>
                </div>

                <div
                    className="w-10 h-10 lg:ml-4 bg-smog-grey rounded-full items-center flex justify-center text-center">
                    <div
                        className={cx(
                            "w-6 h-6 rounded-full flex items-center justify-center text-center",
                            steps === 4 ? 'bg-medal-gold' : 'bg-40',
                        )}
                    >
                        <p className="text-absolute-black">4</p>
                    </div>
                </div>
                <div className="ml-2 flex items-center justify-center text-center text-xs">
                    Terms of Sale
                </div>
            </div>
            {renderSteps()}
            <Popup/>
        </div>
    );
}
